<div id="order-invoice" class="container" style="background: white; min-height: 95vh; width: 80vw;">
  <!-- top row -->
  <div class="row justify-content-between m-4 pt-4">
    <!-- akorion address -->
    <div class="col-4 address">
      <p class="akorion font-weight-bold">Akorion company LTD</p>
      <p>P.O Box 6638, Kampala</p>
      <p>Plot 33 Lumumba Avenue</p>
      <p>Interservice tower 3rd Floor</p>
    </div>
    <!-- invoice details and date-->
    <div class="col-4 header">
      <div class="font-weight-bold blue">
        {{['complete','intransit','delivered'].includes(orderData.status.toLowerCase())?'':'PROFORMA'}} INVOICE</div>
      <div class="font-weight-bold">Number: <span
          class="font-weight-normal">{{orderData.invoice_number||'#INV-'+orderData.code||orderData.id}}</span></div>
      <div class="font-weight-bold">Date: <span class="font-weight-normal">{{date | date:'MM-dd-yyyy'}}</span></div>
    </div>
  </div>
  <!-- empty space -->
  <div class="row mbt-4"></div>

  <!-- row 2 -->
  <div class="row justify-content-between m-4 pt-4">
    <!-- to name -->
    <div class="col-4">
      <div class="font-weight-bold">Bill to:</div>
      <div class="text-uppercase">{{orderData.details.name}}</div>
      <div class="text-uppercase">{{orderData.details.phone}}</div>
    </div>
    <!-- location adrress -->
    <div class="col-4">
      <div class="font-weight-bold text-uppercase">Deliver to:</div>
      <div>{{orderData.details.district}}</div>
      <div>{{orderData.details.subCounty}}</div>
      <div>{{orderData.details.address}}</div>
    </div>

  </div>

  <div class="row m-4 pt-4" *ngIf="['complete','intransit','delivered'].includes(orderData.status.toLowerCase())">
    <div class="col">
      Due for payment on receipt:
    </div>
  </div>
  <!-- row 3 -->
  <div class="row m-4 pt-4">
    <!-- items table -->
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th scope="col">Item</th>
          <th scope="col-2">Description</th>
          <th scope="col">Qty</th>
          <th scope="col">U/M</th>
          <th scope="col">Unit Price</th>
          <th scope="col">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of orderData.order let rowIndex=index">
          <td>{{ order.product }}</td>
          <td>
            {{ order.product_code }}
            <div>{{order.supplier}}</div>
          </td>
          <td>{{ order.qty }}</td>
          <td>{{ order.unit }}</td>
          <td>{{ order.price|currency: 'UGX' }}</td>
          <td>{{ order.price*order.qty |currency: 'UGX' }}</td>
        </tr>
      </tbody>
      <tfoot class="borderless">
        <tr>
          <td colspan="5" class="text-right">SubTotal</td>
          <td>{{subTotal | currency: 'UGX'}}</td>
        </tr>
        <tr>
          <td colspan="5" class="text-right">Transport Cost</td>
          <td>{{transportCost | currency: 'UGX'}}</td>
        </tr>
        <tr>
          <td colspan="5" class="text-right font-weight-bold">Total</td>
          <td class="font-weight-bold">
            {{grandTotal| currency: 'UGX'}}
          </td>
        </tr>
        <tr>
          <td colspan="5" class="text-right">Transport Paid</td>
          <td>{{orderData.transportPaid||0 | currency: 'UGX'}}</td>
        </tr>
        <tr>
          <td colspan="5" class="text-right">Payment/Credits</td>
          <td>{{orderData.amountPaid| currency: 'UGX'}}</td>
        </tr>
        <tr>
          <td colspan="5" class="text-right red">Balance Due</td>
          <td>
            {{outStandingBalance | currency: 'UGX'}}
          </td>
        </tr>
        <tr>
          <td colspan="5" class="text-right font-weight-bold">Total Outstanding Balance</td>
          <td class="font-weight-bold">
            {{outStandingBalance | currency: 'UGX'}}
          </td>
        </tr>
      </tfoot>
    </table>

  </div>

  <!-- payment options -->
  <div class="footer">

    <div class="row m-4 pt-4">
      <div class="col align-self-start font-weight-bold">PAYMENT OPTIONS:</div>
    </div>

    <div class="row m-4 pt-2">
      <!-- opt 1 -->
      <div class="col">
        <div class="font-weight-bold">Option 1: Bank</div>
        <div>Bank name: Stanbic bank</div>
        <div>Bank branch: Forest mall</div>
        <div>A/c Name: Akorion company Ltd</div>
        <div>A/c Number: 9030012684834</div>
        <div>Swiftcode: SBCUGKX</div>
      </div>
      <!-- opt 2 -->
      <div class="col">
        <div class="font-weight-bold">Option 2: MTN mobile money</div>
        <div>1. Dial *165*4*4#</div>
        <div>2. Enter Merchant Code: BEYONIC </div>
        <div>3. Enter Reference: AKORION/{{orderData.details.name||orderData.code}} </div>
        <div>4. Enter Amount </div>
        <div>5. Enter PIN</div>
      </div>
      <!-- opt 3 -->
      <div class="col">
        <div class="font-weight-bold">Option 3: Airtel money</div>
        <div>1. Dial: *185*4*9#</div>
        <div>2. Enter Business Number:998998</div>
        <div>3. Enter Amount </div>
        <div>4. Enter Reason: AKORION/{{orderData.details.name||orderData.code}}</div>
        <div>5. Enter your PIN</div>
      </div>
    </div>
  </div>
  <!-- download button -->
  <div class="row m-4 pb-4 justify-content-center">
    <button class="btn btn-primary btn-lg rounded-pill font-weight-bold">Download EzyAgric App from google play store
      for better prices</button>
  </div>
</div>
